import type { FunctionComponent, ReactNode } from 'react';

import IconCheck from 'assets/images/icon-check-16px.svg';

import './style.scss';

type PropsT = {
  children: ReactNode;
};

const CheckedItem: FunctionComponent<PropsT> = ({ children }) => (
  <div styleName="container">
    <IconCheck />
    {children}
  </div>
);

export default CheckedItem;
